var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isAuthenticated)?_c('Navigation'):_vm._e(),_c('main',{staticClass:"main-content",class:{ 'with-nav': _vm.isAuthenticated }},[(!_vm.isAuthenticated)?_c('router-view'):_c('keep-alive',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }